// Copyright (c) 2021 WiseTime. All rights reserved.

import { Observable, of } from "rxjs"
import { catchError, filter, map, mergeMap } from "rxjs/operators"
import { Action } from "redux"
import { ReorderFavouriteTagRequest, ReorderFavouriteTagResponse } from "generated/legebill/site/tag/v4/tag_pb"
import * as Actions from "../actions"
import { grpc } from "app/rpc/executor"
import { tagServiceClient } from "app/rpc/client"
import { t } from "@lingui/macro"
import { showSnackBar } from "../../snackbar/actions"

type ReorderFavouriteTagRpc = (request: ReorderFavouriteTagRequest) => Observable<ReorderFavouriteTagResponse>

export const reorderFavouriteTag = (reorderFavouriteTagRpc: ReorderFavouriteTagRpc) =>
  (action$: Observable<Action>): Observable<Action> =>
    action$.pipe(
      filter(Actions.reorderFavouriteTag.match),
      mergeMap(({ payload: { request, siteId, }}) =>
        of(request)
          .pipe(
            mergeMap(reorderFavouriteTagRpc),
            map(_ => Actions.fetchFavouriteTags({ siteId })),
            catchError(_ => of(showSnackBar({
              message: t({ id: "msg_reorder_favourite_tag_failed", message: "Failed to reorder favourite tag. Please try again in a couple of minutes. If the error persists, please contact support@wisetime.com." }),
              messageType: "ERROR",
            }))),
          )),
    )

const reorderFavouriteTagRpc = (request: ReorderFavouriteTagRequest): Observable<ReorderFavouriteTagResponse> =>
  grpc(() => tagServiceClient.reorderFavouriteTag(request, null))

export default reorderFavouriteTag(reorderFavouriteTagRpc)
